import * as tslib_1 from "tslib";
import { OnInit, OnDestroy } from '@angular/core';
import { MediaFile, FileNode, ErrorCodes, Error } from 'src/app/utils/common-classes';
import { MatMenuTrigger, MatTableDataSource } from '@angular/material';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { RenameFileDialogComponent } from '../rename-file-dialog/rename-file-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { UploadFileDialogComponent } from '../upload-files-dialog/upload-files-dialog.component';
import { MoveFilesDialogComponent } from '../move-files-dialog/move-files-dialog.component';
export class FileManagerComponent {
    constructor(dialog, fileService, utils, uploadService) {
        this.dialog = dialog;
        this.fileService = fileService;
        this.utils = utils;
        this.uploadService = uploadService;
        this.gridView = true;
        this.files = [];
        this.fileSelection = false;
        this.masterChecked = false;
        this.masterIndeterminate = false;
        this.displayedColumns = ['select', 'name', 'description'];
        this.selection = new SelectionModel(true, []);
        this.contextMenuPosition = { x: '0px', y: '0px' };
    }
    onContextMenu(event, file) {
        event.preventDefault();
        this.selectedFile = file;
        this.contextMenuPosition.x = event.clientX + 'px';
        this.contextMenuPosition.y = event.clientY + 'px';
        this.fileMenuTrigger.menuData = { 'file': file };
        this.fileMenuTrigger.menu.focusFirstItem('mouse');
        this.fileMenuTrigger.openMenu();
    }
    loadFolder(folder, tree) {
        let _self = this;
        if (folder) {
            _self.mediaFolder = folder;
            _self.mediaTree = tree;
            _self.selection.clear();
            _self.files = [];
            _self.utils.showShortLoader();
            _self.fileService.getFiles(folder.mediaFolderId).then((files) => {
                files.forEach((file) => {
                    _self.files.push(FileNode.fromMediaFile(file));
                });
                _self.listDataSource = new MatTableDataSource(_self.files);
            }).catch((err) => {
                return _self.utils.getErrorShowToast(err);
            }).finally(() => {
                _self.utils.hideShortLoader();
            });
        }
    }
    downloadFile(file) {
        let _self = this;
        //window.open(file.url, 'Download'); 
        const a = document.createElement('a');
        a.href = file.url;
        a.download = file.getName(_self.utils.getLanguage());
        a.click();
    }
    renameFile(file) {
        let _self = this;
        let data = { file: file };
        let dialogRef = _self.dialog.open(RenameFileDialogComponent, { width: "600px", data: data, disableClose: true, panelClass: "no-padding-dialog-container", autoFocus: false });
        dialogRef.afterClosed().subscribe((renamedFile) => {
            if (renamedFile) {
                _self.files.splice(_self.files.indexOf(file), 1, renamedFile);
                _self.listDataSource = new MatTableDataSource(_self.files);
            }
        });
    }
    moveFile(file) {
        let _self = this;
        let data = { files: [file], node: _self.mediaFolder, mediaTree: _self.mediaTree };
        let dialogRef = _self.dialog.open(MoveFilesDialogComponent, { width: "50%", data: data, minWidth: "500px", height: "600px", disableClose: true });
        dialogRef.afterClosed().subscribe((movedFiles) => {
            if (movedFiles && movedFiles.length > 0) {
                _self.removeFilesFromList(movedFiles);
            }
        });
    }
    editPreview(fileNode) {
        let _self = this;
        let previewPicker = document.createElement('input');
        previewPicker.type = "file";
        previewPicker.accept = "image/*";
        previewPicker.onchange = (event) => {
            _self.utils.showShortLoader();
            let mediaFile = new MediaFile();
            mediaFile.mediaFileId = fileNode.mediaFileId;
            new Promise((resolve, reject) => {
                let selectedFiles = event.target.files;
                if (selectedFiles && selectedFiles.length == 1) {
                    const file = selectedFiles.item(0);
                    var reader = new FileReader();
                    var img = new Image();
                    img.setAttribute("crossorigin", "anonymous");
                    img.addEventListener('error', function (e) {
                        console.error(e);
                        reject(new Error(ErrorCodes.LOAD_PREVIEW_ERROR));
                    });
                    img.onload = function () {
                        let canvas = document.createElement("canvas");
                        canvas.height = img.height;
                        canvas.width = img.width;
                        let ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);
                        let base64 = canvas.toDataURL();
                        resolve(base64);
                    };
                    reader.readAsDataURL(file);
                    reader.onerror = function (e) {
                        console.error(e);
                        reject(new Error(ErrorCodes.LOAD_PREVIEW_ERROR));
                    };
                    reader.onload = function (data) {
                        img.src = data.target.result;
                    };
                }
                else {
                    reject(new Error(ErrorCodes.FILE_NOT_FOUND));
                }
            }).then((base64) => {
                return _self.uploadService.uploadBase64(base64, 'tmp/preview/media-preview/', null, null);
            }).then((result) => {
                mediaFile.previewUrl = result;
                return _self.fileService.editPreview(mediaFile);
            }).then((data) => {
                fileNode.previewUrl = data.previewUrl;
            }).catch((err) => {
                _self.utils.getErrorShowToast(err);
            }).finally(() => {
                _self.utils.hideShortLoader();
            });
        };
        previewPicker.click();
    }
    deleteFile(file) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let _self = this;
            let title = yield _self.utils.translateKey("dialog.confirm.title.delete-file");
            let message = yield _self.utils.translateKeyWithData("dialog.confirm.message.delete-file", { filename: file.getName(_self.utils.getLanguage()) });
            let data = { title: title, message: message };
            let dialogRef = _self.dialog.open(ConfirmDialogComponent, { width: "400px", data: data, disableClose: true });
            dialogRef.afterClosed().subscribe((del) => {
                if (del) {
                    let mediaFile = new MediaFile();
                    mediaFile.mediaFileId = file.mediaFileId;
                    _self.fileService.deleteFile(mediaFile).then(() => {
                        _self.removeFilesFromList([mediaFile]);
                    }).catch((err) => {
                        return _self.utils.getErrorShowToast(err);
                    }).finally(() => {
                        _self.utils.hideShortLoader();
                    });
                }
            });
        });
    }
    ngOnInit() {
        let _self = this;
        _self.fileMenuTriggerSubscription = _self.fileMenuTrigger.onMenuClose.subscribe(() => {
            _self.selectedFile = null;
        });
        _self.selectionChangeSubscription = _self.selection.changed.subscribe((data) => {
            if (data.added.length > 0) {
                data.added.forEach((file) => {
                    file.checked = true;
                });
            }
            if (data.removed.length > 0) {
                data.removed.forEach((file) => {
                    file.checked = false;
                });
            }
            _self.checkFileSelection();
        });
    }
    ngOnDestroy() {
        let _self = this;
        if (_self.fileMenuTriggerSubscription) {
            _self.fileMenuTriggerSubscription.unsubscribe();
        }
        if (_self.selectionChangeSubscription) {
            _self.selectionChangeSubscription.unsubscribe();
        }
    }
    uploadFiles() {
        let _self = this;
        let data = { folder: _self.mediaFolder };
        let dialogRef = _self.dialog.open(UploadFileDialogComponent, { width: "500px", data: data, height: "400px", disableClose: true });
        dialogRef.afterClosed().subscribe((uploadedFiles) => {
            if (uploadedFiles && uploadedFiles.length > 0) {
                uploadedFiles.forEach((uploadedFile) => {
                    _self.files.push(FileNode.fromMediaFile(uploadedFile));
                    _self.listDataSource = new MatTableDataSource(_self.files);
                });
            }
        });
    }
    //deseleziono eventuali file selezionati
    toggleView() {
        let _self = this;
        _self.gridView = !_self.gridView;
        _self.selection.clear();
    }
    reloadFolder() {
        let _self = this;
        _self.loadFolder(_self.mediaFolder, _self.mediaTree);
    }
    checkFileSelection() {
        let _self = this;
        _self.fileSelection = false;
        _self.files.forEach((file) => {
            if (file.checked) {
                _self.fileSelection = true;
                return;
            }
        });
    }
    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        let _self = this;
        const numSelected = _self.selection.selected.length;
        const numRows = _self.listDataSource.data.length;
        return numSelected === numRows;
    }
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        let _self = this;
        if (_self.isAllSelected()) {
            _self.selection.clear();
        }
        else {
            _self.listDataSource.data.forEach((row) => {
                _self.selection.select(row);
            });
        }
    }
    deleteSelected() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let _self = this;
            let selectedFiles = _self.getSelectedFiles();
            if (selectedFiles && selectedFiles.length > 0) {
                let title = yield _self.utils.translateKey("dialog.confirm.title.delete-files");
                let message = yield _self.utils.translateKey("dialog.confirm.message.delete-files");
                let data = { title: title, message: message };
                let dialogRef = _self.dialog.open(ConfirmDialogComponent, { width: "400px", data: data, disableClose: true });
                dialogRef.afterClosed().subscribe((del) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    if (del) {
                        _self.utils.showShortLoader();
                        let errors = [];
                        let deletedFiles = [];
                        for (let i = 0; i < selectedFiles.length; i++) {
                            let mediaFile = new MediaFile();
                            mediaFile.mediaFileId = selectedFiles[i].mediaFileId;
                            try {
                                yield _self.fileService.deleteFile(mediaFile);
                                deletedFiles.push(mediaFile);
                            }
                            catch (err) {
                                console.error("delete file error", selectedFiles[i]);
                                errors.push(selectedFiles[i]);
                            }
                        }
                        if (errors.length > 0) {
                            let filesList = "";
                            for (let i = 0; i < errors.length; i++) {
                                filesList += errors[i].name;
                                if (i + 1 != errors.length) {
                                    filesList += ", ";
                                }
                            }
                            let message = yield _self.utils.translateKeyWithData("file-manager.error.delete-error", { files: filesList });
                            _self.utils.showErrorToast(message);
                        }
                        else {
                            let message = yield _self.utils.translateKey("file-manager.success.delete-success");
                            _self.utils.showToast(message);
                        }
                        _self.utils.hideShortLoader();
                        _self.removeFilesFromList(deletedFiles);
                    }
                }));
            }
        });
    }
    moveSelected() {
        let _self = this;
        let selectedFiles = _self.getSelectedFiles();
        if (selectedFiles && selectedFiles.length > 0) {
            let data = { files: selectedFiles, node: _self.mediaFolder, mediaTree: _self.mediaTree };
            let dialogRef = _self.dialog.open(MoveFilesDialogComponent, { width: "50%", data: data, minWidth: "500px", height: "600px", disableClose: true });
            dialogRef.afterClosed().subscribe((movedFiles) => {
                if (movedFiles && movedFiles.length > 0) {
                    _self.removeFilesFromList(movedFiles);
                }
            });
        }
    }
    renameSelected() {
        let _self = this;
        let selectedFiles = _self.getSelectedFiles();
        if (selectedFiles && selectedFiles.length == 1) {
            _self.renameFile(selectedFiles[0]);
        }
    }
    getSelectedFiles() {
        let _self = this;
        let selectedFiles = _self.files.filter((file) => {
            return file.checked;
        });
        return selectedFiles;
    }
    removeFilesFromList(removedFiles) {
        let _self = this;
        _self.files = _self.files.filter((file) => {
            let found = false;
            removedFiles.forEach((movedFile) => {
                if (movedFile.mediaFileId == file.mediaFileId) {
                    found = true;
                }
            });
            return !found;
        });
        _self.listDataSource = new MatTableDataSource(_self.files);
        _self.selection.clear();
    }
}
